import SeoMeta from '@/components/seo/SeoMeta';
import HeroBanner from '@/components/features/Home/HeroBanner';
import TopSellerCategoryGrid from '@/components/features/Home/TopSellerCategoryGrid';
import AboutPhilosophy from '@/components/features/Home/AboutPhilosophy';
import QualitySection from '@/components/features/QualitySection';
import EventCateringBlock from '@/components/features/EventCateringBlock';
import SocialProofReviewsBlock from '@/components/features/SocialProofReviewsBlock';
import JournalSection from '@/components/features/Home/JournalSection';

const Home = () => (
    <>
        <SeoMeta page="home" />
        <div className="home-page-container">
            <HeroBanner />
            <TopSellerCategoryGrid />
            <QualitySection />
            <AboutPhilosophy />
            <EventCateringBlock />
            <JournalSection />
            <SocialProofReviewsBlock />
        </div>
    </>
);

export default Home;
